module.exports = __webpack_public_path__ + "e84ff57ac423b70365b1b9c51198be69.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/817.png
// module id = 1720
// module chunks = 2